// Session-cached ArcGIS sublayer metadata (`{base}/{id}?f=json`), shared by the legend
// synthesizer (arcgis-legend.mjs) and the identify presentation loader (arcgis-identify.mjs).
// The PROMISE is cached so concurrent consumers share one request; failures resolve null —
// never reject. A definitive ArcGIS error body stays cached (probed once per page); a
// transient failure (network blip, 5xx) evicts its entry so the next request retries.
const sublayerMetadataCache = new Map();

export function fetchSublayerMetadata(base, id) {
	// esri-leaflet's cleanUrl re-adds a trailing slash to overlay.options.url, so the identify
	// path would otherwise request "{base}//{id}" (rejected by some ArcGIS Enterprise proxies)
	// under a cache key the slash-less legend path never shares.
	const url = `${String(base).replace(/\/+$/, "")}/${id}`;
	let promise = sublayerMetadataCache.get(url);
	if (promise == null) {
		promise = fetch(url + "?f=json", { headers: { Accept: "application/json" } })
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP ${response.status}`);
				}
				return response.json();
			})
			.then((json) => (json != null && typeof json === "object" && json.error == null ? json : null))
			.catch(() => {
				sublayerMetadataCache.delete(url);
				return null;
			});
		sublayerMetadataCache.set(url, promise);
	}
	return promise;
}
